export default {
  'name':	'展商名',
  'enName': '展商英文名',	
  'address': '地址',
  'enAddress': '英文地址',
  'country': '国家',
  'province': '省份',
  'city': '城市',
  'zipCode': '邮编',
  'companyScale': '公司规模',
  'registeredCapital': '注册资本',
  'attendTimes': '参展次数',
  'advertsVideo': '视频',
  'advertsImage': '图片',
  'listed': '是否上市',
  'exhibitionFloor': '展馆号',
  'exhibitionBoothPart': '展位区域',
  'exhibitionBoothNumber': '展位号',
  'itemIntroduction': '展品简介',
  'webUrl': '网址',
  'brand': '品牌名称',
  'introduction': '公司简介',
  'enIntroduction': '英文简介',
  'fax': '传真',
  'telephone': '电话',
  'email': '公司邮箱',
  'linkName': '展商联系人姓名',
  'linkMobile': '展商联系人手机号码',
  'linkEmail': '展商联系人邮箱',
  'linkName1': '展商会务联系人姓名',
  'linkMobile1': '展商会务联系人手机号码',
  'linkEmail1': '展商会务联系人邮箱',
  'yes': '是',
  'no': '否',
  'url3d': '3D展位链接',

  'companyTip': '优质形象 带来信任',
  'companyTip2': '整洁和专业的图片，塑造良好印象，展现实力',
  'companyTip3': '可包括但不限于以下方面',
  'companyTip4': '办公环境优雅',
  'companyTip5': '工厂设备先进',
  'companyTip6': '仓储整洁有序',
  'uploadTip': '此处上传的是企业形象图片，请依据公司情况上传',
  'uploadTip2': '最佳效果尺寸1200*560像素，支持png、jpg格式，不超过2Mb，您最多可上传十张公司图片',
  'companyTitle': '上传宣传视频',
  'companyTip7': '传播企业形象',
  'companyTip8': '促进观众对企业的了解，提升企业品牌附加值，扩大影响，达成共识',
  'uploadTip3': '视频封面和视频为宽屏时，才可获得最佳展示效果',
  'btnText': '添加标签',
  'companyTip9': '准确选择展商标签，帮助您更精准匹配优质买家',
  'companyTip10': '此处上传的是企业logo，请依据企业VI情况上传 ',
  'companyTip11': '最佳效果为在200*200px范围内居中显示，请确保logo图片比例不失真',
  'companyTip13': '支持png、jpg格式，不超过2Mb',

  'exhInfo1': '您上传的资料可以通过IM即时聊天发给意向观众',
  'exhInfo2': '注意：支持png、jpg格式图片，PDF、Word、Excel、PPT格式格式文件,MP4、MOV格式视频，不超过10Mb',


}